<section class="m-3 rounded-xl border border-slate-300 bg-white p-4 text-slate-800 shadow-sm" aria-label="Hindsight 查詢">
  <h2 class="mb-2 text-xl font-semibold">RAG（Hindsight）查詢</h2>
  <p class="mb-4 text-sm text-slate-600">Recall 檢索記憶；Reflect 依記憶生成回答（使用 LLM）。Bank 使用後端設定。</p>
  <p class="mb-3 text-sm">目前設定：{{ mode }} / {{ budget }} / max_tokens {{ maxTokens }}。可至 Hindsight 設定修改。</p>
  <form (ngSubmit)="search()">
    <fieldset [disabled]="busy()" class="grid min-w-0 gap-3">
      <label class="grid gap-1">查詢內容
        <textarea class="w-full rounded border p-2" name="query" [(ngModel)]="query" rows="3" placeholder="產品 A 保固多久？" required></textarea>
      </label>
      <div class="flex flex-wrap gap-2">
        <button class="btn-primary" type="submit" [disabled]="!query.trim()">{{ mode === 'reflect' ? '生成回答（Reflect）' : '查詢記憶（Recall）' }}</button>
      </div>
    </fieldset>
  </form>
  <div aria-live="polite" class="mt-3">
    @if (busy()) { <p role="status">處理中，請稍候…</p> }
    @if (error()) { <p role="alert" class="text-red-700">{{ error() }}</p> }
  </div>
  @if (details() !== null) {
    <details class="mt-2"><summary>錯誤詳細資料</summary><pre class="overflow-auto whitespace-pre-wrap break-all text-sm">{{ details() | json }}</pre></details>
  }
  @if (response(); as result) {
    @if (completedMode() === 'reflect') {
      <h3 class="mt-4 font-semibold">生成回答</h3>
      <p class="whitespace-pre-wrap wrap-break-word">{{ result.text }}</p>
    }
    <h3 class="mt-4 font-semibold">{{ completedMode() === 'recall' ? '檢索結果' : '參考記憶' }}</h3>
    @for (fact of (result.results ?? result.based_on?.memories ?? []); track $index) {
      <article class="mt-2 rounded border border-slate-200 p-3">
        <p class="whitespace-pre-wrap wrap-break-word">{{ fact.text }}</p>
        <p class="mt-2 break-all text-sm text-slate-500">類型：{{ fact.type || '未提供' }} · 文件：{{ fact.document_id || '未提供' }}</p>
        @if (fact.context) { <p class="whitespace-pre-wrap wrap-break-word text-sm">{{ fact.context }}</p> }
        <details class="mt-2"><summary>來源詳細資料</summary><pre class="overflow-auto whitespace-pre-wrap break-all text-sm">{{ fact | json }}</pre></details>
      </article>
    } @empty { <p class="mt-2 text-slate-500">{{ completedMode() === 'recall' ? '查無符合的記憶。' : '此次回答未提供參考記憶。' }}</p> }
    <details class="mt-3"><summary>完整回應（含來源及用量）</summary><pre class="overflow-auto whitespace-pre-wrap break-all text-sm">{{ result | json }}</pre></details>
  }
</section>
